import React from 'react';
import { useParams } from 'react-router-dom';
import {
  usePlmEventByIdQuery,
  PlmEvent,
} from '../../../../types/generated-types';
import { PlmEventDetailForm } from './plmEvent-detail-form';
import { Box, CircularProgress, Typography } from '@mui/material';

export const PlmEventEdit = () => {
  const { id } = useParams<{ id: string }>();

  const { data, loading, error } = usePlmEventByIdQuery({
    variables: { _id: id! },
    skip: !id,
  });

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">
          Error loading PLM event: {error.message}
        </Typography>
      </Box>
    );
  }

  if (!data?.plmEventById) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">PLM event not found</Typography>
      </Box>
    );
  }

  return <PlmEventDetailForm plmEvent={data.plmEventById as PlmEvent} />;
};
